/**
 * API COVERAGE — PublicController (/api/public) [unauthenticated, tenant-aware]
 *   GET /api/public/company-branding      → publicApi.branding
 *   GET /api/public/company-branding/logo → publicApi.logoUrl (image stream)
 */
import { api, apiBase, http } from '@/lib/apiClient';

// Tenant-aware but UNAUTHENTICATED endpoints (resolved via X-Tenant / subdomain).
// Used by the login/register screens to theme the page before sign-in.
export interface PublicBranding {
  companyName: string;
  logoFileId?: number | null;
  primaryColor: string;
  secondaryColor: string;
}

export const publicApi = {
  /** GET /api/public/company-branding — public branding for the resolved tenant. */
  branding: () => api.get<PublicBranding>('/public/company-branding'),
  /** Direct URL to the tenant's public logo stream. */
  // logoUrl: () => '/api/public/company-branding/logo',
   logoUrl: () => `${apiBase}/public/company-branding/logo`,
  /** Logo as a blob (tenant-aware via the X-Tenant header on the client). */
  logoBlob: async (): Promise<Blob> =>
    (await http.get('/public/company-branding/logo', { responseType: 'blob' })).data as Blob,
};
